module.exports = __webpack_public_path__ + "static/media/deadly-7.58b45d27.png";